import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"key"}/>
}
